export default __webpack_public_path__ + "fe6924369fdcfe0790df1755f773ff60.png";